import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

/* Widget */
import { Icon, ICON } from 'widget/icon'

/* Styles */
import './index.css'

import Menu from './menu'

/* Single Playlist List Item */
export default class DropdownButton extends Component {

  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  componentWillReceiveProps(nextProps) {
    if( this.props.open === nextProps.open ) return
    this.setState({ open: nextProps.open })
  }

  onFocus() {

  }

  onBlur() {
    this.setState({ open:false })
  }

  toggleOpen() {
    this.setState({ open: !this.state.open })
  }

  onClick(e) {
    this.toggleOpen()
    e.stopPropagation()
  }

  onClose() {
    this.setState({ open: false })
  }

  onButtonMouseDown(e) {
    // stop focus loss
    e.stopPropagation()
    e.preventDefault()
  }

  getClassName() {
    const {
      className,
      circle
    } = this.props
    let classNameArr = (className || "").split(' ')
    classNameArr.push('dropdown-button', 'widget')
    if (this.state.open) classNameArr.push('open')
    if (circle) classNameArr.push('no-button')
    return  classNameArr.join(' ')
  }

  renderDropdownMenu() {
    if(!this.state.open) return null
    const { menu, align } = this.props
    return (
      <Menu { ...menu } onClose={ this.onClose.bind(this) }/>
    )
  }

  renderLabel() {
    const {
      label
    } = this.props
    if (!label) return null
    return label
  }

  render() {
    const {
      title,
      circle,
      icon,
      iconScheme
    } = this.props
    return (
      <button
        className={ this.getClassName() }
        title={ title }
        ref={ (elem) => { this.button = elem } }
        onClick={ this.onClick.bind(this)}
        onFocus={ this.onFocus.bind(this) }
        onBlur={ this.onBlur.bind(this) }
      >
        { this.renderLabel() }
        <Icon
          icon={ icon || ICON.MENU }
          scheme={ iconScheme }
          size={ 24 }
          circle={ circle }
          interactive={true}
        />
        { this.renderDropdownMenu() }
      </button>
    )
  }
}

DropdownButton.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  menu: PropTypes.object,
  circle: PropTypes.bool,
  icon: PropTypes.func, // should be a React Class
  iconScheme: PropTypes.number,
}



// WEBPACK FOOTER //
// ./src/app/widget/dropdown-button/index.jsx